<template>
  <div class="row">
    <div class="col-sm-12"><br>
      <div
        class="container-fluid col-md-12"
        style="
          background: rgb(248, 249, 250);
          border-radius: 10px;
          box-shadow: 5px 5px 5px 5px #999999;
        "
        id="contenedor"
      >
      <router-link :to="{ name: 'menu' }">
				<br><h6>Volver</h6>
            </router-link>
     <div class="d-flex justify-content-center">
        
							<div class="row">
								<div class="col">
								<br>
								<img src="https://seguimiento.cmimbral.cl/assets/logo_tienda.png"  width="200" class="img-fluid" alt="Responsive image"><br>
								</div>
							</div>
							
    </div><br>

    <div class="d-flex justify-content-center">
        
							<div class="row">
								<div class="col">
								<h3 class="text-center"><b>Personal Mimbral</b></h3><br>
                </div>
							</div>
							
    </div>
    
    <div id="bDocumento">
        
          <div class="row">
            <div class="col-sm-3"></div>
            <div class="col-sm-5">
              <input type="text" class="form-control "  id="persona" placeholder="Ingrese RUT o nombre" required="true"  style="border-color:rgb(237,126,37)">
            </div>
            <div class="col-sm">
              <button type="submit"  id="btnBuscar" class="btn btn-primary " @click="buscarPersona()"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37)"><i class="fas fa-search"></i></button>
            </div>
          </div>
        </div><br><br>
     <div class="d-flex justify-content-center">
        
							<div class="row">
								<div class="col">
								<div>
        <table class="table table-striped table-responsive" style="display:block">
           <thead style="background-color:rgb(0,58,140);color:white">
            <tr>
              <th>RUT</th>
              <th>NOMBRE</th>
              <th>SUCURSAL</th>
              <th>AREA</th>
              <th>CUPO</th>
              <th>CUPO DISP.</th>
              <th>EDITAR</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="x in Personas" :key="x.key">
              <td>{{ x.rut }}</td>
              <td>{{ x.nombre }}</td>
              <td>{{ x.sucursal }}</td>
              <td>{{ x.area }}</td>
              <td>{{ x.cupo }}</td>
              <td>{{ x.cupodisponible }}</td>
              <td>
                
                <button 
                
                  type="button"
                  
                  class="btn btn-success btn-sm"
                  style="
                    background-color: rgb(0, 56, 143);
                    color: white;
                    border-color: rgb(237, 126, 37);
                  "
                  @click="editarCupo(x.key,x.nombre,x.cupo,x.cupodisponible)"
                >
                 <i class="fas fa-edit fa-2x"></i>
                </button>
              </td>
              
            </tr>
          </tbody>
        </table>
        <br>
          
        
        </div>
                </div>
							</div>
							
    </div><br>
						<div class="d-flex justify-content-center">
              <button type="submit"  id="btnBuscar" class="btn btn-success " @click="addPersona()"><i class="fas fa-plus"></i></button>
            </div>	
              <br>
            <div class="d-flex justify-content-center">
              <button type="submit"  id="btnBuscar" class="btn btn-danger " @click="limpiarCupos()">LIMPIAR CUPOS</button>
            </div>	

        <br>
         
       
       <!-- <iframe id="pdf" width="100%" height="800px"></iframe>-->
      </div>
    </div>
    <div>

   <b-modal id="modal-1" hide-footer hide-header >
    
    <div class="d-block text-center">
      <h3><b>Agregar Producto</b></h3><br>
           
                <div class="row">
                    <div class="col-sm-6">
                         <div class="form-group">
                        <label>DESCRIPCIÓN</label>
                        <input type="text" id="descripcion"  class="form-control" placeholder="Ingrese descripción" style="border-color:rgb(237,126,37)"  required>
                        </div>
                    </div>
                    <div class="col-sm-6">
                       <div class="form-group">
                        <label>PRECIO</label>
                        <input type="text" id="precio"  class="form-control" placeholder="Ingrese precio aprox." style="border-color:rgb(237,126,37)" required>
                        </div>
                    </div>
                    
                    
                </div><br>
                
                
                
                <div class="row">
                    <div class="form-group">
                        <label for="observacion">Observacion</label>
                        <textarea class="form-control" id="observacion" rows="3"  style="border-color:rgb(237,126,37)"></textarea><br>
                    </div>
                </div>
               <!-- <div class="row" >
                    <div class="col-sm-6">
                        <input style="border-color:rgb(237,126,37)" @change="clickImagen($event)" type="file" accept="image/*" >
                    </div>

                </div>--><br>

                
                <div class="d-flex justify-content-center">
                    <div class="form-group">
                        <button class="btn btn-primary btn-block" @click="agregarProducto2()" style="background-color: rgb(0, 56, 143); color: white; border-color: rgb(237, 126, 37);">Agregar</button><br><br>
                    </div>
                </div>

    </div>

  </b-modal>   



  <b-modal id="modal-cupos"  hide-footer hide-header >
    
    <div class="d-block text-center">
      <h3><b>Limpiar Cupos</b></h3><br>
      <label>Ingrese la clave para poder continuar</label>
                <div class="input-group mb-3">
                
                      
                        <input type="password" id="claveCupos" v-model="claveCupos" class="form-control" placeholder="Clave" style="border-color:rgb(237,126,37)" required>
                        <span class="input-group-text" id="basic-addon1" @click="mostrarClave()"><i class="fas fa-eye"></i></span>
                    </div>
               
                

                
                <div class="d-flex justify-content-center">
                    <div class="form-group">
                        <button id="botonLiberar" class="btn btn-primary btn-block" @click="verificarClave()" style="background-color: rgb(0, 56, 143); color: white; border-color: rgb(237, 126, 37);">Liberar</button><br><br>
                    </div>
                </div>

    </div>

  </b-modal>

  <b-modal id="modal-2"  hide-footer hide-header >
    
    <div class="d-block text-center">
      <h3><b>Editar Cupo</b></h3><br>
      
                
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>CUPO</label>
                        <input type="text" id="cupoEditar" v-model="cupoEditar" class="form-control" placeholder="Ingrese cupo máximo" style="border-color:rgb(237,126,37)" required>
                        </div>
                    </div>
                    <div class="col-sm-6">
                      <label>ESTADO</label>
                      <select class="form-select" aria-label="Default select example" id="estadoEditar" style="border-color: rgb(237, 126, 37);">
                      <option value="ACTIVO">ACTIVO</option>
                      <option value="INACTIVO">INACTIVO</option>
                      </select>
                    </div>
                   
                </div><br>
                
                
               <!-- <div class="row" >
                    <div class="col-sm-6">
                        <input style="border-color:rgb(237,126,37)" @change="clickImagen($event)" type="file" accept="image/*" >
                    </div>

                </div>--><br>

                
                <div class="d-flex justify-content-center">
                    <div class="form-group">
                        <button class="btn btn-primary btn-block" @click="editarProducto2()" style="background-color: rgb(0, 56, 143); color: white; border-color: rgb(237, 126, 37);">Editar</button><br><br>
                    </div>
                </div>

    </div>

  </b-modal>

  <b-modal id="modal-persona"  size="xl" hide-footer hide-header >
    
    <div class="d-block text-center">
      <h3><b>Agregar Persona</b></h3><br>
           
                <div class="row">
                    <div class="col-sm-6">
                         <div class="form-group">
                        <label>RUT</label>
                        <input type="text" id="rutNuevo"  class="form-control" placeholder="Ingrese RUT" style="border-color:rgb(237,126,37)"  required>
                        </div>
                    </div>
                    <div class="col-sm-6">
                       <div class="form-group">
                        <label>NOMBRE</label>
                        <input type="text" id="nombreNuevo"  class="form-control" placeholder="Ingrese nombre" style="border-color:rgb(237,126,37)" required>
                        </div>
                    </div>
                </div><br>
                <div class="row">
                    <div class="col-sm-6">
                         <div class="form-group">
                        <label>AREA</label>
                        <input type="text" id="areaNuevo"  class="form-control" placeholder="Ingrese área" style="border-color:rgb(237,126,37)"  required>
                        </div>
                    </div>
                    <div class="col-sm-6">
                       <div class="form-group">
                        <label>CARGO</label>
                        <input type="text" id="cargoNuevo"  class="form-control" placeholder="Ingrese cargo" style="border-color:rgb(237,126,37)" required>
                        </div>
                    </div>
                </div><br>
                 <div class="row">
                    <div class="col-sm-6">
                         <div class="form-group">
                        <label>RAZON</label>

                      <select class="form-select" aria-label="Default select example" id="razonNuevo" style="border-color: rgb(237, 126, 37);" @change="cambiarRutRazon()">
                        <option value="ANA MARIA GONZALEZ ZUÑIGA">ANA MARIA GONZALEZ ZUÑIGA</option>
                        <option value="ARTRAN SAN JAVIER LIMITADA">ARTRAN SAN JAVIER LIMITADA</option>
                        <option value="CENTRO DE EVENTOS LA HORQUETA SPA">CENTRO DE EVENTOS LA HORQUETA SPA</option>
                        <option value="JOSE ANTONIO GONZALEZ BURGOS">JOSE ANTONIO GONZALEZ BURGOS</option>
                        <option value="SERVICIOS Y SUMINISTROS AURI LTDA.">SERVICIOS Y SUMINISTROS AURI LTDA.</option>
                        <option value="SOCIEDAD COMERCIAL EL MIMBRAL LIMITADA">SOCIEDAD COMERCIAL EL MIMBRAL LIMITADA</option>
                        <option value="SOCIEDAD DE TRANSPORTES EL MIMBRAL LTDA">SOCIEDAD DE TRANSPORTES EL MIMBRAL LTDA</option>
                        <option value="SOCIEDAD DE TRANSPORTES Y SERVICIOS ANI LIMITADA">SOCIEDAD DE TRANSPORTES Y SERVICIOS ANI LIMITADA</option>
                        <option value="SUMINISTROS ANA MARIA GONZALEZ ZUÑIGA EIRL">SUMINISTROS ANA MARIA GONZALEZ ZUÑIGA EIRL</option>
                      </select>
                       <!-- <input type="text" id="razonNuevo"  class="form-control" placeholder="Ingrese razón social" style="border-color:rgb(237,126,37)"  required>-->
                        </div>
                    </div>
                    <div class="col-sm-6">
                       <div class="form-group">
                        <label>RUT RAZON</label>
                        <input type="text" id="rutrazonNuevo"  class="form-control" placeholder="Ingrese RUT razón social" style="border-color:rgb(237,126,37)" required>
                        </div>
                    </div>
                </div><br>
                <div class="row">
                    <div class="col-sm-6">
                         <div class="form-group">
                        <label>CUPO</label>
                        <input type="text" id="cupoNuevo"  class="form-control" placeholder="Ingrese cupo" style="border-color:rgb(237,126,37)"  required>
                        </div>
                    </div>
                    <div class="col-sm-6">
                       <div class="form-group">
                        <label>CUPO DISPONIBLE</label>
                        <input type="text" id="cupodisponibleNuevo"  class="form-control" placeholder="Ingrese cupo disponible" style="border-color:rgb(237,126,37)" required>
                        </div>
                    </div>
                </div><br>
                <div class="row">
                    <div class="col-sm-6">
                         <div class="form-group">
                        <label>ESTADO</label>
                        <select class="form-select" aria-label="Default select example" id="estadoNuevo" style="border-color:rgb(237,126,37)">
                        <option value="ACTIVO">ACTIVO</option>
                        <option value="INACTIVO">INACTIVO</option>
                        </select></div>
                    </div>
                    <div class="col-sm-6">
                       <div class="form-group">
                        <label>SUCURSAL</label>
                        <select class="form-select" aria-label="Default select example" id="sucursalNuevo" style="border-color:rgb(237,126,37)">
                          <option value="Barros Negros">Barros Negros</option>
                          <option value="Centro Comercial">Centro Comercial</option>
                          <option value="Marimaura">Marimaura</option>
                          <option value="Transportes">Transportes</option>
                        
                       
                        </select></div>
                    </div>
                </div><br>
               <!-- <div class="row" >
                    <div class="col-sm-6">
                        <input style="border-color:rgb(237,126,37)" @change="clickImagen($event)" type="file" accept="image/*" >
                    </div>

                </div>--><br>
                <div class="d-flex justify-content-center">
                    <div class="form-group">
                        <button class="btn btn-primary btn-block" @click="agregarPersona()" style="background-color: rgb(0, 56, 143); color: white; border-color: rgb(237, 126, 37);">Agregar</button><br><br>
                    </div>
                </div>
                

    </div>

  </b-modal>   
</div>
  </div>
  
</template>

<script>
import { db } from "../firebaseDb";
//import { storage } from "../firebaseDb";
import Swal from "sweetalert2";
import Vue from 'vue'
    import { BootstrapVue } from 'bootstrap-vue'
    Vue.use(BootstrapVue)
//const ref = storage.ref();

export default {
  data() {
    return {
      Personas: [],
      vendedores:[],
      editado:[],
      chequeEditado:[],
      observacion:'',
      sku:'',
      descripcion:'',
      precio:'',
      stock:'',
      FoliosSap:[],
      FoliosAsignar:[],
      totalFoliosAsignar:0,
      resumenFoliosAsignar:'',
      montoTransferencia:0,
      diferenciaMontos:0,
      idDocumentoFb:'',
      foliosAntiguos:'',
      rutBuscarFolios:'',
      fecha2BF:'',
      fecha1BF:'',
      tipoMonto:'',
      skuEditar:'',
      descripcionEditar:'',
      cupoEditar:'',
      keyEditar:'',
      cupoActual:'',
      claveCupos:'',
    };
  },
  created() {
   
            this.usuario=localStorage.nombreUsuario;
            //console.log(this.usuario)
            //this.cargarProductos();
            this.validarUsuario();  
   
    
  },
  methods: {
    mostrarClave(){
      console.log("clave")
      document.getElementById("claveCupos").type="text"
      setTimeout(function() {
        document.getElementById("claveCupos").type="password"
        // Otras acciones que deseas realizar después de 2 segundos
      }, 2000);
    },
    limpiarCupos(){
      this.$bvModal.show("modal-cupos")
    },
    verificarClave(){
      if(this.claveCupos=="mimbral2023"){
        if(confirm("Desea actualizar los cupos?")){
          this.limpiarCupos2()
        }
      }else{
        Swal.fire({
          title: "Error",
          text: "Clave incorrecta",
          icon: "warning",  
        })
      }
    },
    limpiarCupos2(){
          document.getElementById("botonLiberar").style.display="none"
          db.collection('colaborador').onSnapshot((snapshotChange) => {
                 
                      snapshotChange.forEach((doc) => {
                        console.log(doc.id)
                        db.collection('colaborador').doc(doc.id)
                        .update({cupodisponible:doc.data().cupo}).then(() => {
                            console.log("actualizado")
                        }).catch((error) => {
                            console.log(error);
                        });
                          /*  this.Personas.push({
                            key: doc.id,
                            rut: doc.data().rut,
                            nombre: doc.data().nombre,
                            area: doc.data().area,
                            sucursal: doc.data().sucursal, 
                            cupo: doc.data().cupo, 
                            cupodisponible: doc.data().cupodisponible, 
                        })*/
                    
                  });
                 
            })
      },


    addPersona(){
       this.$bvModal.show("modal-persona")
    },
   
    agregarPersona(){
      var rut=document.getElementById("rutNuevo").value;
      db.collection('colaborador').where("rut", "==", rut).get().then((doc) => {
                if(doc.empty==true){
                  this.agregarPersona2()
                }else{
                  Swal.fire({
                      title: "Error",
                      text: "La persona ya está registrada",
                      icon: "warning",
                  })
                }
      }).catch((error) => {
                console.log(error)
      })

    },
    agregarPersona2(){
      var rut=document.getElementById("rutNuevo").value;
      var nombre=document.getElementById("nombreNuevo").value;
      var area=document.getElementById("areaNuevo").value;
      var cargo=document.getElementById("cargoNuevo").value;
      var razon=document.getElementById("razonNuevo").value;
      var rutrazon=document.getElementById("rutrazonNuevo").value;
      var cupo=document.getElementById("cupoNuevo").value;
      var cupodisponible=document.getElementById("cupodisponibleNuevo").value;
      var estado=document.getElementById("estadoNuevo").value;
      var sucursal=document.getElementById("sucursalNuevo").value;
      if(rut!=""&&nombre!=""&&area!=""&&cargo!=""&&razon!=""&&rutrazon!=""&&cupo!=""&&cupodisponible!=""&&estado!=""&&sucursal!=""){
          console.log(rut)
          var persona=new Object()
          persona.rut=rut;
          persona.nombre=nombre;
          persona.area=area;
          persona.cargo=cargo;
          persona.razon=razon;
          persona.rutrazon=rutrazon;
          persona.cupo=cupo;
          persona.cupodisponible=cupodisponible;
          persona.estado=estado;
          persona.sucursal=sucursal;

          db.collection('colaborador').add(persona).then(() => {
                        Swal.fire({
                          title: "Listo",
                          text: "Personal Registrado",
                          icon: "success",
                        })
                        this.$bvModal.hide("modal-persona")
          })
      }else{
        Swal.fire({
                          title: "Error",
                          text: "Complete los campos",
                          icon: "warning",
                        })
      }
      
    },

    buscarPersona(){
        var rut=document.getElementById("persona").value.toUpperCase();
        db.collection('colaborador').where("rut", "==", rut).onSnapshot((snapshotChange) => {
                this.Personas = [];
                if(snapshotChange.empty){
                   this.buscarPersona2()
                }else{
                    snapshotChange.forEach((doc) => {
                      console.log(doc.data())
                          this.Personas.push({
                          key: doc.id,
                          rut: doc.data().rut,
                          nombre: doc.data().nombre,
                          area: doc.data().area,
                          sucursal: doc.data().sucursal, 
                          cupo: doc.data().cupo, 
                          cupodisponible: doc.data().cupodisponible, 
                      })
                   
                });
                }
          })
    },

    buscarPersona2(){
        var rut=document.getElementById("persona").value.toUpperCase();
        db.collection('colaborador').orderBy('nombre').startAt(rut).endAt(rut+'\uf8ff').onSnapshot((snapshotChange) => {
                this.Personas = [];
                if(snapshotChange.empty){
                   Swal.fire({
                      title: "Error",
                      text: "No se encontraron datos",
                      icon: "error",
                    });
                }else{
                    snapshotChange.forEach((doc) => {
                          this.Personas.push({
                          key: doc.id,
                          rut: doc.data().rut,
                          nombre: doc.data().nombre,
                          area: doc.data().area,
                          sucursal: doc.data().sucursal, 
                          cupo: doc.data().cupo, 
                          cupodisponible: doc.data().cupodisponible, 
                      })
                   
                });
              }
          })
    },

    editarCupo(key,nombre,cupoActual,cupodisponible){
      console.log(cupodisponible)
      //console.log(key,nombre)
       this.$bvModal.show("modal-2")
       this.keyEditar=key;
       this.cupoActual=cupoActual;
       this.cupoDisponible=cupodisponible
       //document.getElementById("keyEditar").value=key
       
    },

    editarProducto2(){
      var cupo=document.getElementById("cupoEditar").value;
      var estado=document.getElementById("estadoEditar").value;
      var cupoActual=this.cupoActual;
      var dif=parseInt(cupo)-parseInt(cupoActual)
      console.log(cupo,cupoActual,dif,this.cupoDisponible)
      var nuevoDisponible=parseInt(this.cupoDisponible)+parseInt(dif)
      console.log(nuevoDisponible)
      if(cupo!="" && estado!=""){
        db.collection('colaborador').doc(this.keyEditar)
                        .update({cupo:cupo,cupodisponible:nuevoDisponible}).then(() => {
                            Swal.fire({
                                title: "Listo",
                                text: "Cupo Actualizado",
                                icon: "success",
                            })
                            this.$bvModal.hide("modal-2")
                            document.getElementById("cupoEditar").value=""
                            document.getElementById("estadoEditar").value=""
                            //document.getElementById("keyEditar").value=""
                        }).catch((error) => {
                            console.log(error);
                        });
      }else{
          Swal.fire({
                        title: "Error",
                        text: "Debe completar los campos",
                        icon: "error",
                    })
      }
                        
    },
    
    cambiarRutRazon(){
      /* <select class="form-select" aria-label="Default select example" id="razonNuevo" style="border-color: rgb(237, 126, 37);" onchange="cambiarRutRazon()">
                        <option value="ANA MARIA GONZALEZ ZUÑIGA">ANA MARIA GONZALEZ ZUÑIGA</option>
                        <option value="ARTRAN SAN JAVIER LIMITADA">ARTRAN SAN JAVIER LIMITADA</option>
                        <option value="CENTRO DE EVENTOS LA HORQUETA SPA">CENTRO DE EVENTOS LA HORQUETA SPA</option>
                        <option value="JOSE ANTONIO GONZALEZ BURGOS">JOSE ANTONIO GONZALEZ BURGOS</option>
                        <option value="SERVICIOS Y SUMINISTROS AURI LTDA.">SERVICIOS Y SUMINISTROS AURI LTDA.</option>
                        <option value="SOCIEDAD COMERCIAL EL MIMBRAL LIMITADA">SOCIEDAD COMERCIAL EL MIMBRAL LIMITADA</option>
                        <option value="SOCIEDAD DE TRANSPORTES EL MIMBRAL LTDA">SOCIEDAD DE TRANSPORTES EL MIMBRAL LTDA</option>
                        <option value="SOCIEDAD DE TRANSPORTES Y SERVICIOS ANI LIMITADA">SOCIEDAD DE TRANSPORTES Y SERVICIOS ANI LIMITADA</option>
                        <option value="SUMINISTROS ANA MARIA GONZALEZ ZUÑIGA EIRL">SUMINISTROS ANA MARIA GONZALEZ ZUÑIGA EIRL</option>
                      </select>*/

      var razon=document.getElementById("razonNuevo").value;             
      if(razon=="ANA MARIA GONZALEZ ZUÑIGA"){
        document.getElementById("rutrazonNuevo").value="11745073-2"
      }else if(razon=="ARTRAN SAN JAVIER LIMITADA"){
        document.getElementById("rutrazonNuevo").value="76835178-3"
      }else if(razon=="CENTRO DE EVENTOS LA HORQUETA SPA"){
        document.getElementById("rutrazonNuevo").value="76460902-6"
      }else if(razon=="JOSE ANTONIO GONZALEZ BURGOS"){
        document.getElementById("rutrazonNuevo").value="6760280-3"
      }else if(razon=="SERVICIOS Y SUMINISTROS AURI LTDA."){
        document.getElementById("rutrazonNuevo").value="76835175-9"
      }else if(razon=="SOCIEDAD COMERCIAL EL MIMBRAL LIMITADA"){
        document.getElementById("rutrazonNuevo").value="76004335-4"
      }else if(razon=="SOCIEDAD DE TRANSPORTES EL MIMBRAL LTDA"){
        document.getElementById("rutrazonNuevo").value="78993940-3"
      }else if(razon=="SOCIEDAD DE TRANSPORTES Y SERVICIOS ANI LIMITADA"){
        document.getElementById("rutrazonNuevo").value="76275809-1"
      }else if(razon=="SUMINISTROS ANA MARIA GONZALEZ ZUÑIGA EIRL"){
        document.getElementById("rutrazonNuevo").value="76262227-0"
      }
    },
     validarUsuario(){
             //document.getElementById("monto").display = "none";   
            if(this.usuario==undefined || this.usuario=="X"){
                this.$router.push('/')
            }
        },

      leer(){
                var rut = document.getElementById("rut").value;
				var rutx=rut.replace("-","");
				var largo=rutx.length
				//console.log(largo,largo-1)
				var rut2=rutx.slice(0,largo-1)
				var rut3=rutx.slice(largo-1)
                //console.log(rut2+"-"+rut3)
				document.getElementById("rut").value=(rut2+"-"+rut3)
				
        },
     
    
  },
};
</script>

<style>
.btn-primary {
  margin-right: 12px;
}
</style>